// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__R49K9","productName":"Table_productName__3CdS2"};